import { pagesData as pagesDataRaw } from '@internal/pagesData';
import { ref } from 'vue';
/**
 * Global pages data ref
 */
export const pagesData = ref(pagesDataRaw);
/**
 * Returns the ref of data resolvers of all pages
 */
export const usePagesData = () => pagesData;
